import styled from 'styled-components';
import { ArrowIcon } from '../../atoms/icons/ArrowIcon';

export const Arrow = styled(ArrowIcon)`
  height: 1.1rem;
  width: 1.1rem;
  margin: 0 0.5rem;
  fill: ${({ theme }) => theme.colors.darkBlue};
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
`;
